import React, { useCallback } from 'react';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import cx from 'classnames';

import Icon from 'components/Icon';
import IconButton from 'components/IconButton';
import { PAGE_ROUTES } from 'lib/page-routes';
import { useGlobalSearch } from 'lib/providers/GlobalSearchProvider';

import styles from './NonOnboardedUserBanner.module.scss';

const NonOnboardedUserBanner: React.FC = () => {
  const router = useRouter();
  const { closeOnboardingBanner } = useGlobalSearch();
  const [t] = useTranslation('search.results');
  const handleOnboard = useCallback(() => router.push(`${PAGE_ROUTES.CANDIDATE_ONBOARDING}?matching_preference=true`), [router]);

  return (
    <section className={styles.container}>
      <Icon iconName="info" size="auto" className={styles.icon} />
      <div>
        <p className={styles.label}>{t('non-onboarded-user-banner.title')}</p>
        <button className={cx(styles.action, styles.cta)} onClick={handleOnboard}>
          {t('non-onboarded-user-banner.cta')}
        </button>
      </div>

      <div className={styles.actions}>
        <button className={styles.action} onClick={handleOnboard}>
          {t('non-onboarded-user-banner.cta')}
        </button>
        <IconButton iconName="cancel" className={styles.close} onClick={closeOnboardingBanner} />
      </div>
    </section>
  );
};

NonOnboardedUserBanner.displayName = 'NonOnboardedUserBanner';

export default NonOnboardedUserBanner;
